import './PracticesList.scss'

import SubscriptionContext from 'components/common/contexts/SubscriptionContext'
import { useContext, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import PracticeCard from '../PracticeCard'
import { isFreePracticeCategory } from 'components/common/api/Practices'
import {
  EVENT_ACTION_PAGEVIEW,
  EVENT_CATEGORY_PRACTICES,
  saveUserEvent
} from 'components/common/api/UserEvents'

/**
 * Practices List component: used to render a list of practices
 * @param {String} type - the type of practices to render
 * @param {Array} data - the data to render
 * @param {String} baseUrl - the base URL to use for the practice links
 * @param {String} lockedReturnPath - the path to return to after encountering a locked practice
 * @returns {JSX.Element}
 */
export default function PracticesList({
  practiceType,
  data,
  baseUrl,
  lockedReturnPath
}) {
  const { userSubscription: subscription, userHasPremiumAccess } =
    useContext(SubscriptionContext)
  const [isLocked, setIsLocked] = useState(true)

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0)

    // Return early if we don't have type or subscription data
    if (!practiceType || !subscription) return

    // Does the user have a valid subscription?
    setIsLocked(!userHasPremiumAccess)

    // Log access
    saveUserEvent(
      EVENT_CATEGORY_PRACTICES,
      EVENT_ACTION_PAGEVIEW,
      `${practiceType} list`
    )
  }, [practiceType, subscription, userHasPremiumAccess])

  return (
    data?.length > 0 && (
      <Row xs={1} sm={2} xl={3} className='practices-list'>
        {data.map((item, i) => (
          // Don't show Breathwork or Meditations unless the user is staff
          <Col key={i}>
            <PracticeCard
              title={item.name}
              practiceId={item.term_id}
              baseUrl={baseUrl}
              style={{ animationDelay: `${0.05 * i}s` }}
              // Check to see if the current practice is free
              isLocked={
                isLocked && !isFreePracticeCategory(practiceType, item.term_id)
              }
              lockedReturnPath={lockedReturnPath}
              practiceType={practiceType}
            />
          </Col>
        ))}
      </Row>
    )
  )
}
